
//SVG Ajax Loading
export function svgLoad() {
    let ajax = new XMLHttpRequest();
    ajax.open("GET", "/images/sprite.svg", true);
    //ajax.open("GET", "assets/template/images/sprite.svg", true);
    ajax.send();
    ajax.onload = function (e) {
        let block = document.createElement('div');
        block.innerHTML = ajax.responseText;
        block.classList.add('svg-sprite-wrap');
        document.body.insertBefore(block, document.body.childNodes[0]);
    };
}

export function svgFix(){
    //SVG fix
    document.addEventListener("DOMContentLoaded", function () {
        let baseUrl = window.location.href
            .replace(window.location.hash, "");

        [].slice.call(document.querySelectorAll("use[*|href]"))

            .filter(function (element) {
                return (element.getAttribute("xlink:href").indexOf("#") === 0);
            })

            .forEach(function (element) {
                element.setAttribute("xlink:href", baseUrl + element.getAttribute("xlink:href"));
            });

    }, false);
}

